<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button type="primary" @click.native="RestartOrder" :disabled="!canWrite">新增</el-button>

      <el-button
        type="primary"
        @click.native="save"
        :disabled="data.Status == 2 || !canWrite"
        >保存</el-button
      >
      <!--  @click.native="orderReview" -->
      <el-button
        type="primary"
        @click.native="orderReview"
        :disabled="!isSave || !canReview"
        >{{ ReviewName }}</el-button
      >
      <el-button
        type="primary"
        @click.native="orderDel"
        :disabled="data.Status == 2 || !canWrite"
        >删除</el-button
      >
      <el-button
        type="primary"
        @click.native="toPrint"
        :disabled="!isSave"
        >打印</el-button
      >
      <!-- <el-button @click="close">关 闭</el-button> -->
    </div>
    <el-form
      ref="dialog"
      :data="data"
      label-width="100px"
      :model="data"
      :rules="rules"
      :inline="true"
    >
      <el-row class="border">
        <el-row>
          <el-form-item label="费用单编号" prop="DocNo">
            <span v-if="mode == 0 || isDetails" class="not-edit">{{
              data.DocNo
            }}</span>
            <el-input
              v-else
              v-model="data.DocNo"
              style="width: 193px"
            ></el-input>
          </el-form-item>
          <el-form-item label="单据日期" prop="DocDate">
            <span class="not-edit" v-if="isDetails">{{
              $commonJs.toDateString(data.DocDate)
            }}</span>
            <el-date-picker
              v-else
              v-model="data.DocDate"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              :editable="false"
              style="width: 193px"
              @change="(v) => getPreviewNo(v)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="往来单位"
            prop="TradeUnitId"
            :rules="data.NeedTradeUnit ? tu : null"
          >
            <span class="not-edit" v-if="isDetails">{{
              data.TradeUnitName
            }}</span>
            <!-- <select-input
              v-else
              placeholder="请选择单位"
              :label="data.TradeUnitName"
              v-model="data.TradeUnitId"
              @click="openTradeunit"
            /> -->
            <el-select
              v-else
              v-model="data.TradeUnitId"
              filterable
              style="width: 180px"
            >
            <div
              style="
                max-height: 274px;
                overflow: scroll;
                margin-bottom: -17px;
                margin-right: -17px;
              "
            >
              <el-option
                v-for="item in tradeUnitList"
                :key="item.TradeUnitId"
                :value="item.TradeUnitId"
                :label="item.FullName"
                @click.native="setTradeunit(item)"
              ></el-option>
            </div>
            
            </el-select>
          </el-form-item>
          <el-form-item label="票据类型" prop="InvoiceTypeId">
            <span class="not-edit" v-if="isDetails">{{
              data.InvoiceTypeName
            }}</span>
            <el-select
              v-else
              style="width: 180px"
              @change="invoiceChange"
              v-model="data.InvoiceTypeId"
            >
              <el-option
                v-for="item in invoiceList"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="业务类型" prop="BusinessTypeId">
            <span class="not-edit" v-if="isDetails">{{
              data.BusinessType
            }}</span>
            <business-select
              v-else
              v-model="data.BusinessTypeId"
              :params="{ Kind: '应付', SourceType: '费用单' }"
              @change="onChange"
            />
          </el-form-item> -->
          <el-form-item label="经办人" prop="ClerkId">
            <span class="not-edit" v-if="isDetails">{{ data.ClerkName }}</span>
            <select-input
              v-else
              placeholder="请选择经办人"
              :label="data.ClerkName"
              v-model="data.ClerkId"
              @click="openEmp"
            />
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="备注:" prop="Remark">
            <span class="not-edit" v-if="isDetails">{{ data.Remark }}</span>
            <el-input
              v-else
              type="textarea"
              v-model="data.Remark"
              :autosize="{ minRows: 2, maxRows: 4 }"
              maxlength="60"
              placeholder="请填写备注信息"
              style="width: 600px"
            />
          </el-form-item>
        </el-row>
      </el-row>
      <template v-if="data.InvoiceTypeId != null">
        <edit-list2
          v-if="data.InvoiceTypeName == '收据'"
          ref="editList"
          :IsDetail="isDetails"
          :invoiceStatus="invoiceStatus"
        />
        <edit-list1
          v-else
          ref="editList"
          :invoiceStatus="invoiceStatus"
          :IsDetail="isDetails"
        />
      </template>
      <div class="row-tb-head" style="margin-top: 10px">
        <span>付款信息</span>
        <div style="float: right" v-if="!isDetails">
          <el-button type="primary" icon="el-icon-plus" @click="addReceipt"
            >添加</el-button
          >
        </div>
      </div>
      <el-table border class="table-line tb-c-head" :data="data.RpCostDocPays">
        <el-table-column
          prop="SettleName"
          label="结算方式"
          min-width="110"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{ row.SettleName }}</span>
            <el-select
              v-else
              v-model="row.SettleId"
              @change="setSettle(row)"
              placeholder="请选择结算方式"
            >
              <template v-for="(i, key) in Settles">
                <el-option
                  :label="i.SettleName"
                  :value="i.SettleId"
                ></el-option>
              </template>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="AccountName" label="付款账号" align="center">
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{ row.AccountName }}</span>
            <select-input
              v-else
              placeholder="请选择账号"
              :label="row.AccountName"
              v-model="row.AccountId"
              @click="openAccount(row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="PayAmount" label="付款金额" align="center" v-if="canPrice">
          <template slot-scope="{ row }">
            <span v-if="isDetails">{{
              $commonJs.toThousands(row.PayAmount)
            }}</span>
            <el-input
              v-else
              v-model="row.PayAmount"
              @input="onInput(row)"
              type="number"
              placeholder="请输入付款金额"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="95"
          fixed="right"
          v-if="!isDetails"
        >
          <template slot-scope="{ row, $index }">
            <!-- <el-link style="margin-right:10px" @click="copyRow(row,$index)" :underline="false">复制</el-link> -->
            <el-link @click="delReceipt(row, $index)" :underline="false"
              >删除</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <!-- <common-dialog ref="dialog" width="1100px" line-form unit="费用单" edit-title id-key="DocId" :data="data"
      :get-data-func="api.info" form-label-width="95px" @create-opened="onCreateOpened" @edit-opened="onEditOpened"
      @opened="onOpened" :form-rules="rules" @closed="onClosed">
    
      <template slot="footer" slot-scope="{isLoading}">
        
        <el-button type="primary" :loading="isLoading" @click="save('save')">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>

      
    </common-dialog> -->

    <account-dialog
      ref="accountDialog"
      in-dialog
      selectable
      @select="setAccount"
    />
    <tradeunit-dialog
      ref="tradeunitDialog"
      in-dialog
      selectable
      @select="setTradeunit"
    />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import accountDialog from "@/components/basedata/finance/account/listDialog";
import businessSelect from "@/components/basedata/basedoc/business/select";
import invoiceSelect from "@/components/basedata/finance/invoice/select";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
import empDialog from "@/components/personnel/result/record/listDialog";
import editList1 from "@/components/finance/dealings/cost/editList1";
import editList2 from "@/components/finance/dealings/cost/editList2";

export default {
  name: "editCost",
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    accountDialog,
    businessSelect,
    invoiceSelect,
    tradeunitDialog,
    empDialog,
    editList1,
    editList2,
  },
  data() {
    return {
      api: require("@/api/rp/costDoc").default,
      code_api: require("@/api/sy/serialCode").default,
      settle_api: require("@/api/ba/settle").default,
      cost_api: require("@/api/ba/cost").default,
      getInvoiceApi: require("@/api/ba/invoiceType").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      mode: 0,
      invoiceStatus: true,
      invoiceList: [],
      data: {
        DocId: 0,
        DocNo: "", //编号
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        UnitType: 0, //类型 - 1:零售 2:批发 3:供应商
        // DocType: null,
        SourceDocId: null,
        SourceDocNo: "",
        SourceBillName: "",
        BusinessTypeId: 0, //业务类型
        InvoiceTypeId: null, //票据类型 - 0:不开票 SY_InvoiceType
        InvoiceTypeName: "",
        ClerkId: null, //经办人
        ClerkName: "",
        Amount: null, //金额
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        NoTaxAmount: null, //无税金额
        ReceiptAmount: null, //收款税额
        RemainAmount: null, //剩余金额
        Remark: "", //备注
        NeedTradeUnit: true,

        RpCostDocDtss: [],
        RpCostDocPays: [],
      },

      DelRpCostDocPays: [],
      current: null,
      Settles: [], //结算方式列表
      Cost: [], //费用
      tradeUnitList: [],
      rules: {
        DocNo: [{ required: true, message: "费用单编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        ClerkId: [{ required: true, message: "请选择经办人" }],
        // BusinessTypeId: [{ required: true, message: "请选择业务类型" }],
        InvoiceTypeId: [{ required: true, message: "请选择票据类型" }],
      },
      tu: [{ required: true, message: "请选择单位" }],
    };
  },
  computed: {
    isDetails() {
      return Boolean(this.data.Status === 2);
    },
    isSave() {
      return Boolean(this.data.DocId > 0);
    },
    ReviewName() {
      return this.data.Status == 2 ? "弃审" : "审核";
    },
    canPrice() {
      return this.$permission.canPrice("/finance/dealings/cost");
    },
    canWrite() {
      return this.$permission.canWrite("/finance/dealings/cost");
    },
    canReview() {
      return this.$permission.canReview("/finance/dealings/cost");
    },
  },
  beforeMount() {
    this.onOpened();
    this.getCurd();
  },
  created(){
    this.init();
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      this.getInvoiceApi.list({ Status: 1 }).then((res) => {
        if (res.Code === 0) {
          this.invoiceList = res.Data.map((item) => {
            return {
              key: item.InvoiceTypeId,
              label: item.InvoiceTypeName,
              value: item.InvoiceTypeId,
            };
          });
        }
      });
      this.tradeUnitApi
        .list({ TradeUnitTypes: [1, 2, 3], Status: 1 })
        .then((res) => {
          if (res.Code == 0) {
            this.tradeUnitList = res.Data;
          }
        });
    },
    invoiceChange(e) {
      let index = this.invoiceList.findIndex((el) => e == el.key);
      this.data.InvoiceTypeName = this.invoiceList[index].label;
      //  if(this.invoiceList[index].label=='收据'){this.invoiceStatus=false}else{this.invoiceStatus=true}
      this.invoiceStatus = this.invoiceList[index].label != "收据";
      //  console.log(this.Cost,'this.Cost')
      this.$nextTick(() => {
        this.$refs.editList.setCost(this.Cost);
      });
    },
    getCurd() {
      const mode = this.$route.params.mode;
      const row = this.$route.params.data ?? {};
      switch (mode) {
        case "create":
          this.onCreateOpened();
          break;
        case "edit":
          this.onEditOpened(row.DocId);
          break;
        case "editById":
          this.onEditOpened(row.DocId);
          break;
        case "details":
          this.onDetailsOpened(row);
          break;
        case "review":
          this.onReviewed(row);
          break;
        default:
          this.onCreateOpened();
          break;
      }
    },
    onDetailed() {
      this.isDetails = true;
    },
    onReviewed() {
      this.isDetails = false;
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("费用单", dateTime).then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取费用单编号失败");
        }
      });
    },
    onCreateOpened() {
      var user = this.$store.state.user;
      this.data.DocDate = this.$commonJs.getToday();
      // console.log("user", JSON.parse(JSON.stringify(user)));
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
      this.getPreviewNo();
      this.init();
      // this.addReceipt();
    },
    onEditOpened(data, type = 0) {
      console.log("data", data);
      this.api
        .info(data)
        .then((res) => {
          if (res.Code === 0) {
            res.Data.RpCostDocDts = res.Data.RpCostDocDtsDtos.map((x) => {
              return { ...x, T: 3 };
            });
            res.Data.RpCostDocPays = res.Data.RpCostDocPayDtos.map((x) => {
              return { ...x, T: 3 };
            });
            this.data = res.Data;
            console.log("this.data", this.Data);

            if (type === 1) {
              this.Review();
            }
          }
        })
        .then(() => {
          this.$refs.editList.setData(this.data.RpCostDocDts);
          this.$refs.editList.setCost(this.Cost);
        });

      // Object.assign(this.data,data)
    },
    onDetailsOpened(data) {
      console.log("data", data);
      this.api
        .info(data.DocId)
        .then((res) => {
          if (res.Code === 0) {
            res.Data.RpCostDocDts = res.Data.RpCostDocDtsDtos.map((x) => {
              return { ...x, T: 3 };
            });
            res.Data.RpCostDocPays = res.Data.RpCostDocPayDtos.map((x) => {
              return { ...x, T: 3 };
            });
            this.data = res.Data;
            console.log("this.data", this.Data);
          }
        })
        .then(() => {
          this.$refs.editList.setData(this.data.RpCostDocDts);
          this.$refs.editList.setCost(this.Cost);
        });

      // Object.assign(this.data,data)
    },
    RestartOrder() {
      // this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this));
      this.onOpened();
      this.onCreateOpened();
      // this.add();

      setTimeout(() => {
        this.$refs.dialog.clearValidate();
      }, 30);
    },
    Review() {
      this.api.examine(this.data.DocId).then((res) => {
        this.data.Status = 2;
        res.Code === 0
          ? this.$message.success(res.Msg)
          : this.$message.warning(res.Msg);

        if (res.Code === 0) {
          this.editOrder(this.data.DocId);
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      });
    },
    orderReview() {
      if (this.data.DocId == 0) {
        this.$message.warning("订单未保存");
        return;
      }

      const message =
        this.data.Status == 2 ? "确认要弃审吗？ " : "确认提交审核吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = this.data.Status == 2 ? "cancel" : "examine";
          if (data === "examine") {
            this.save(1);
          } else if (data === "cancel") {
            this.api[data](this.data.DocId).then((res) => {
              if (res.Code === 0 && data == "examine") {
                this.data.Status = 2;
              }
              if (res.Code === 0 && data == "cancel") this.data.Status = 0;
              res.Code === 0
                ? this.$message.success(res.Msg)
                : this.$message.warning(res.Msg);

              if (res.Code === 0) {
                this.editOrder(this.data.DocId);
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            });
          }
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.DocId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Id: this.data.DocId }).then((res) => {
            if (res.Code === 0) this.RestartOrder();
            res.Code === 0
              ? this.$message.success(res.Msg)
              : this.$message.warning(res.Msg);
          });
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    onOpened() {
      this.settle_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Settles = res.Data;
      });
      this.cost_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Cost = res.Data;
      });
    },
    onChange(data) {
      if (data) this.data.NeedTradeUnit = data.NeedTradeUnit;
      else this.data.NeedTradeUnit = true;
      this.$refs.dialog.clearValidate();
    },
    // invoiceChange(data) {
    //   console.log("invoiceChange", data);
    //   this.data.InvoiceTypeName = data.InvoiceTypeName;
    //   this.$nextTick(() => {
    //     this.$refs.editList.setCost(this.Cost, data.DefTaxRate);
    //   });
    // },
    addReceipt() {
      var item = {
        DocReceiptId: 0,
        DocId: this.data.DocId,
        SettleId: null,
        SettleName: "",
        AccountId: null,
        AccountName: "",
        PayAmount: null, //收款金额
        T: 0,
      };
      this.data.RpCostDocPays.push(item);
    },
    setSettle(row) {
      console.log("setSettle", row);
      var settle = this.Settles.find((x) => x.SettleId == row.SettleId);
      if (row.T !== 0) {
        row.T = 1;
      }
      row.AccountId = settle.AccountId;
      row.AccountName = settle.AccountName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    openAccount(row) {
      this.current = row;
      this.$refs.accountDialog.open().then((that) => {
        that.getData();
      });
    },
    setAccount(data) {
      if (this.current.T !== 0) {
        this.current.T = 1;
      }
      this.current.AccountId = data.AccountId;
      this.current.AccountName = data.AccountName;
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      // this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
    },
    onInput(row) {
      row.T = row.T == 0 ? 0 : 1;
      // row.PayAmount = this.$commonJs.obj.toNumber(row.PayAmount);
      var items = this.data.RpCostDocPays.filter((x) => !!x.PayAmount).map(
        (x) => parseFloat(x.PayAmount)
      );
      var amount = null;
      if (items.length > 0) {
        amount = items.reduce((a, b) => {
          return a + b;
        });
      }
      this.data.ReceiptAmount = amount;
    },
    delReceipt(row, index) {
      if (row.T != 0) this.DelRpCostDocPays.push({ ...row, T: 2 });
      this.data.RpCostDocPays.splice(index, 1);
    },
    save(type = 0) {
      this.$refs.dialog.validate().then((valid) => {
        if (!valid) return;

        var data = this.$commonJs.obj.removeNullKey(this.data);
        data.RpCostDocDtss = this.$refs.editList.Data.filter(
          (x) => x.CostId != 0
        );

        if (data.RpCostDocDtss.length == 0) {
          this.$message.warning("费用信息不能为空");
          return;
        }
        var incomeId = data.RpCostDocDtss.every((x) => !!x.CostId);
        if (!incomeId) {
          this.$message.warning("费用信息 - 费用名称不能为空");
          return;
        }
        var amount = data.RpCostDocDtss.every((x) => !!x.Amount);
        if (!amount) {
          this.$message.warning("费用信息 - 金额不能为空");
          return;
        }

        if (data.InvoiceTypeName != "收据") {
          //TaxAmount  税额
          // var taxRate = data.RpCostDocDtss.some((x) => x.TaxRate === "");
          console.log(data.RpCostDocDtss, "data.RpCostDocDtss");

          if (
            data.RpCostDocDtss[0].TaxAmount == null ||
            data.RpCostDocDtss[0].TaxAmount == 0
          )
            return this.$message.warning("费用信息 - 税率不能为空");

          data.RpCostDocDtss.forEach((x) => {
            if (x.TaxAmount == null) x.TaxAmount = 0;
          });
          // var taxAmount = data.RpCostDocDtss.every((x) => !!x.TaxAmount);
          // if (!taxAmount) {
          //   this.$message.warning("费用信息 - 税额不能为空");
          //   return;
          // }
          // var incTaxAmount = data.RpCostDocDtss.every(
          //   (x) => !!x.IncTaxAmount
          // );
          // if (!incTaxAmount) {
          //   this.$message.warning("费用信息 - 含税金额不能为空");
          //   return;
          // }
        } else {
          data.RpCostDocDtss.forEach((x) => {
            if (x.TaxAmount == null) x.TaxAmount = 0;
            if (x.IncTaxAmount == null) x.IncTaxAmount = 0;
          });
        }

        // if (data.RpCostDocPays.length == 0) {
        //   this.$message.warning("付款信息不能为空");
        //   return;
        // }
        var settleId = data.RpCostDocPays.every((x) => !!x.SettleId);
        if (!settleId) {
          this.$message.warning("付款信息 - 结算方式不能为空");
          return;
        }
        var accountId = data.RpCostDocPays.every((x) => !!x.AccountId);
        if (!accountId) {
          this.$message.warning("付款信息 - 账号不能为空");
          return;
        }
        var payAmount = data.RpCostDocPays.every((x) => !!x.PayAmount);
        if (!payAmount) {
          this.$message.warning("付款信息 -付款金额不能为空");
          return;
        }

        var DelRpCostDocDtss = this.$refs.editList.DelData;
        data.RpCostDocDtss = data.RpCostDocDtss.filter((x) => x.T != null);
        data.RpCostDocDtss.forEach((x) => (x.DocId = this.data.DocId));
        DelRpCostDocDtss.forEach((x) => {
          data.RpCostDocDtss.push(x);
        });

        data.RpCostDocPays = data.RpCostDocPays.filter((x) => x.T != null);
        this.DelRpCostDocPays.forEach((x) => {
          data.RpCostDocPays.push(x);
        });
        if (data.RpCostDocPays.length > 0) {
          var docAmount = data.RpCostDocPays.filter((item) => item.T !== 2)
            .map((item) => {
              return parseFloat(item.PayAmount);
            })
            .reduce((total, number) => {
              return total + number;
            });
          var incomAmount = data.RpCostDocDtss.filter((item) => item.T !== 2)
            .map((item) => {
              return parseFloat(item.Amount);
            })
            .reduce((total, number) => {
              return total + number;
            });
          if (docAmount != incomAmount) {
            this.$message.warning("费用金额和付款金额不一致");
            return;
          }
        }

        if (data.RpCostDocDtss[0].TaxAmount == null)
          data.RpCostDocDtss[0].TaxAmount = 0;
        if (data.RpCostDocDtss[0].IncTaxAmount == null)
          data.RpCostDocDtss[0].IncTaxAmount = 0;
        this.$refs.dialog.isLoading = true;
        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            if (type !== 1) {
              this.$message.success(res.Msg);
            }
            const id = this.data.DocId == 0 ? res.Data : this.data.DocId;
            this.onEditOpened(id, type);
            this.onClosed();
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    toPrint() {
      let newpage = this.$router.resolve({
        path: '/costPrint?id=' + this.data.DocId
      })
      window.open(newpage.href, '_blank');
    },
    onClosed() {
      this.DelRpCostDocPays = [];
      this.data.RpCostDocPays = [];
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.dropdown-item {
  padding: 5px 10px;
}
.detail-span {
  padding-left: 0;
  display: inline-block;
}
.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}
.dropdown-item {
  padding: 5px 10px;
}
</style>
